/**
 * Version 1 strategy document fields (prose + universe + cadence). Kept in
 * their own module so `agents.ts` (requests, read models) and `strategy.ts`
 * (the v2 spec) can both import them without an import cycle.
 */
import { z } from 'zod'
import { Address, UsdString } from '../primitives.js'
import { RiskProfile } from '../enums.js'

export const StrategyUniverse = z.object({
  minLiquidityUsd: UsdString,
  maxTokenAgeDays: z.number().int().positive().optional(),
  allowlist: z.array(Address).optional(),
  denylist: z.array(Address).optional(),
})
export type StrategyUniverse = z.output<typeof StrategyUniverse>

export const StrategyCadence = z.object({
  tickIntervalS: z.number().int().min(10),
  reviewIntervalS: z.number().int().min(60),
})

export const Strategy = z.object({
  thesis: z.string().min(1).max(4000),
  universe: StrategyUniverse,
  signals: z.array(z.string().min(1)).min(1),
  entry: z.string().min(1),
  exit: z.string().min(1),
  cadence: StrategyCadence,
  riskProfile: RiskProfile,
})
export type Strategy = z.output<typeof Strategy>
